import { classNames, ExternalLink } from "@indietabletop/appkit";
import { Fragment } from "react/jsx-runtime";
import { paragraph } from "../utils.css";
import { FathomEvent, trackEvent } from "./fathom";
import { parseSegments } from "./parseSegments";
import { handleLink, standaloneButton } from "./style.css";

function getContent(para: string, isRichText: boolean) {
  if (!isRichText) {
    return para;
  }

  const segments = parseSegments(para);
  return segments.map((segment, i) => {
    switch (segment.type) {
      case "plain": {
        return <Fragment key={i}>{segment.value}</Fragment>;
      }

      case "link": {
        return (
          <ExternalLink
            key={i}
            href={segment.href}
            onClick={() => trackEvent(FathomEvent.EXTERNAL_LINK_CLICK)}
            className={handleLink({ isBold: !!segment.label })}
          >
            {segment.label || segment.href}
          </ExternalLink>
        );
      }

      case "button": {
        return (
          <ExternalLink
            key={i}
            href={segment.href}
            onClick={() => trackEvent(FathomEvent.EXTERNAL_LINK_CLICK)}
            className={standaloneButton}
          >
            {segment.label}
          </ExternalLink>
        );
      }

      default: {
        const unknown: never = segment;
        console.warn(`Encountered unknown segment type.`, unknown);
        return null;
      }
    }
  });
}

export function Paragraphs(props: { text: string; className?: string; richText?: boolean }) {
  const { text, className, richText = true } = props;

  return (
    <>
      {text.split(/\n+/).map((para, index) => {
        const content = getContent(para, richText);

        return (
          <p key={index} className={classNames(paragraph, className)}>
            {content}
          </p>
        );
      })}
    </>
  );
}
